import React from 'react'
import { Spinner } from 'reactstrap'
import { toast } from 'react-toastify'


const Loader = (props) => {
    return (
        <React.Fragment>
            <div className="d-flex justify-content-center align-items-center m-2 h-100" data-testid="loader">
                <Spinner color="primary"> Loading... </Spinner>
            </div>
            {props.error && toast.error(props.error, { position: 'top-right', hideProgressBar: false, progress: undefined, toastId: '' })}
        </React.Fragment>
    )
}

export default Loader
